import { extend } from 'flarum/extend';
import HeaderSecondary from 'flarum/components/HeaderSecondary';

export default function () {
  extend(HeaderSecondary.prototype, 'items', function(items) {
    delete items.items['flags'];
  });
}
